import Phi from '../../../Phi/Phi'

import React, { Component } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import moment from 'moment'
import { ToastContainer } from 'react-toastify';
import { withCookies } from 'react-cookie'

import Loader from 'dataphi-react-components/dist/Containers/DataphiLoader/Component/LoaderComponent'

import './App.css'
import '../../../Themes/Generic.css'

import history from '../../../history'
import NavDrawer from '../../NavDrawerContainer';
import HSGHeader from '../../HSGHeaderContainer'
import HSGFooter from '../../HSGFooterContainer'
import HSGTabs from '../../HSGTabs'
import Dashboard from '../../DashboardContainer'
import ManageProfile from '../../ManageProfileContainer'
import Report from '../../ReportContainer'
import Student from '../../StudentContainer'
import StudentCustom from '../../StudentCustomContainer'
import StudentList from '../../StudentListContainer'
import UploadDocument from '../../UploadDocumentContainer'
import Support from '../../SupportContainer'
import HSGPopupComponent from '../Component/HSGPopupComponent'
import SmartClinic from  '../../SmartClinicContainer'
import Validator from 'dataphi-react-components/dist/Containers/FormScreen/FormComponent/Validator'

const HEADER_DESCRIPTION = 'DESIGNED BY DOCTORS, LOVED BY PARENTS'

const changePasswordValidator = field1 => field2 => field1 === field2 ? null : `Passwords do not match.`

var findArrayIndex = function (array, predicateFunction) {
    var length = array == null ? 0 : array.length;
    if (!length) {
        return -1;
    }
    var index = -1;
    for (var i = 0; i < array.length; ++i) {
        if(predicateFunction(array[i])) {
            index = i;
            break;
        }
    }
    return index;
}

const changePasswordDefs = {
    submitButton: {
      text: 'CHANGE PASSWORD',
      className: {
        fieldClassName: "btn hsg-btn-primary wide",
        groupClassName: "wide",
      }
    },
    closeButton: { text: "Cancel", className: "", hide: true },
    metaData: [
      {
        name: "password1",
        type: "password",
        className: {
          fieldClassName: 'hsg-input',
          groupClassName: 'hsg-input-grp col-md-12 col-sm-12 col-xs-12',
          errorClassName: 'hsg-error',
          labelClassName: 'hsg-input-label'
        },
        label: "NEW PASSWORD",
        validation: [Validator.required]
      },
      {
        name: "password2",
        type: "password",
        className: {
          fieldClassName: 'hsg-input',
          groupClassName: 'hsg-input-grp col-md-12 col-sm-12 col-xs-12',
          errorClassName: 'hsg-error',
          labelClassName: 'hsg-input-label'
        },
        label: "CONFIRM PASSWORD",
        validation: [Validator.required]
      }
    ]
  };

const SECTIONS = [
    'dashboard',
    'student',
    'upload'
];
class App extends Component {

    constructor(props) {
        super(props)

        this.state = {
            dim: {
                width: 0,
                height: 0,
                contentHeight: 0,
                headerHeight: 0
            },
            showChangePasswordPopup: false,
            showNavDrawer: false
        }

        this.headerElement = null

        this.updateDimensions = this.updateDimensions.bind(this)
    }

    // Lifecycle Methods ==============================================================      
    componentDidMount() {
        this.setState({dim: this.getDim()})

        window.addEventListener("resize", this.updateDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions)
    }

    changeTab = (nav, type) => {
        let startNode = this.props.startNodeMap[nav]
        
        const activeTabMap = {
            year: () => {
                this.props.fetchStudentList(Object.assign({}, this.props.studentHeader, { startNode: startNode.id, inOffset: 0, inSearchString: '' }))
                this.props.changeReportInReducer(nav)
                // this.props.getReport('overview', { eventNodeId: nav, type: 'html' })
            }
        }

        activeTabMap[type]()
    }

    _renderYearTab = (program, history) => {

        let tabs = []
        
        let getLabel = (createdTime, duration) => {

            if (createdTime && duration) {

                let startDate = moment(createdTime).format("MMM' YY")
                // let durationObj = moment.duration(Number(duration), 'months')
                let durationObj = moment.duration(Number(12), 'months')
                let endDate = moment(createdTime).add(durationObj).format("MMM' YY")

                return `${startDate} - ${endDate}`
            } else {
                return null
            }
        }

        tabs = history && history.length && history.map(programNode => {
            let label = getLabel(programNode.billing.inBillingStartDate, programNode.billing.agreement_duration)

            return {
                nav: programNode.billing.id,
                label: label,
                badge: 0
            }
        })


        let activeTab = program && program.billing ? program.billing.id : null

        return <div className="hsg-year-tab col-md-12 col-sm-12 col-xs-12">

            <HSGTabs selected={activeTab} changeTab={(index, nav) => this.changeTab(nav, 'year')}>
                {
                    tabs && tabs.map((tab, i) => {
                        return (
                            <div key={i} nav={tab.nav} label={tab.label} badge={tab.badge}></div>
                        )
                    })
                }
            </HSGTabs>

        </div>

    }

    handlePasswordChange = data => {
        const cookies = this.props.cookies
        cookies.remove('token', {path: '/'})
        cookies.remove('roles', {path: '/'})
        this.props.changePassword(data.password1)
        this.props.logoutUser()
        this.showChangePasswordModal(false)
    }

    handleFormChange = ({name, value}) => {
        name === 'password1' && this.props.changeFieldValue('password2',null)
        this.setState({[name]: value})
    }

    showChangePasswordModal = (val) => this.setState({showChangePasswordPopup: !!val})

    getChangePasswordModal = () => {
        let defs = changePasswordDefs
        changePasswordDefs.metaData[1].validation[1] = changePasswordValidator(this.state.password1)
        const getHeader = () => (
            <div className="center">
                <b className="center">Change Password</b>
                <p className="hsg-input-label center">Do you want to change your password ?</p>
                <p className="hsg-error center">You will be logged out in the process</p>
            </div>
        )
        return (
            <HSGPopupComponent
                    show={this.state.showChangePasswordPopup}
                    onHide={()=>this.showChangePasswordModal(false)}
                    onClose={()=>this.showChangePasswordModal(false)}
                    header={getHeader()}
                    isForm={true}
                    formDefs={defs}
                    onFieldBlur = {(data) => this.handleFormChange(data)}
                    onSubmit = {data => this.handlePasswordChange(data)}
            />
        )
    }

    render() {
        const { currentProgram } = this.props
        const pathname = this.props.location.pathname;        
        const  selectedSection = findArrayIndex(SECTIONS, (item) => pathname.indexOf(item) === 1);

        const sectionList = [
            {text: 'DASHBOARD',
            icon: 'eye-open',
            onClick: () => { history.push('/' + SECTIONS[0]) },
            selected: selectedSection === 0},
            {text: 'STUDENT LIST',
            icon: 'user',
            onClick: () => { history.push('/' + SECTIONS[1]) },
            selected: selectedSection === 1},
            {text: 'UPLOAD',
            icon: 'cloud',
            onClick: () => { history.push('/' + SECTIONS[2]) },
            selected: selectedSection === 2},
            {text: 'MY PROFILE',
            icon: 'user',
            onClick: () => { history.push('/manage-profile') },
            selected: selectedSection === -1}
        ]

        const linkList = [
            {
                text: 'Change Password',
                icon: 'fas fa-key',
                onClick: () => { this.showChangePasswordModal(true) }
            },
            {
                text: 'Support',
                icon: 'fas fa-question-circle',
                onClick: () => { history.replace('/support') }
            },
            {
                text: 'Logout',
                icon: 'fas fa-sign-out-alt',
                onClick: () => { this.props.logoutUser() }}
        ]

        const userCustom = Phi.User.userCustomJson()
        const jsonValue = userCustom ? userCustom.json_value : null

        return (
            <div>
            <section 
                ref={(e) => {this.rootElement = e}}
                className="hsg-app-container"
                style={{overflow: this.state.showNavDrawer ? 'hidden' : 'visible', minHeight: this.state.dim.width >= 768 ? 768 : 200 }}>
                    
                    <div className="hsg-app-container" style={{paddingTop: this.state.dim.headerHeight}}>

                        {
                            !!!this.props.location.pathname.startsWith('/report') && <HSGHeader
                                    dim={this.state.dim}
                                    heading={HEADER_DESCRIPTION}
                                    setHeaderElement={(e) => {this.setHeaderElement(e)}}
                                    onClickManageProfile={() => { history.push('/manage-profile') }}
                                    onClickChild={() => {}}
                                    changePassword={()=>this.showChangePasswordModal(true)}
                                    onClickAddChild={() => {}}
                                    onClickSupport={() => {history.push('/support')}}
                                    location={this.props.location}
                                    logout={() => {}} 
                                    onClickNavDrawer={() => this.setState({showNavDrawer: true})}/>
                        }    
                        
                        {                       
                            this.props.location.pathname === "/student" && this._renderYearTab(currentProgram, this.props.history)
                        }

                        <Loader blockUI={true} isLoading={this.props.isLoading} message={this.props.message}/>
                        
                        <Switch>

                            <Route path="/dashboard" render={(props) => (
                                <Dashboard location={props.location} dim={this.state.dim} />
                            )} />


                            <Route path="/manage-profile" render={(props) => (
                                <ManageProfile dim={this.state.dim} />
                            )} />

                            <Route exact path="/report/student/:startNodeId/:type/:hsgId" render={(props) => (
                                <Report match={props.match} dim={this.state.dim} />
                            )} />

                            <Route path="/report/school/:startNodeId/:type" render={(props) => (
                                <Report match={props.match} dim={this.state.dim} />
                            )} />

                            <Route path="/student" render={(props) => (
                                <Student dim={this.state.dim} />
                            )} />

                            {<Route path="/infirmary" render={(props) => (
                                <StudentCustom dim={this.state.dim} />
                            )} />}

                            <Route path="/student-list" render={(props) => (
                                <StudentList dim={this.state.dim} />
                            )} />

                            <Route path="/smart-clinic" render={(props) => (
                                <SmartClinic dim={this.state.dim} />
                            )} />

                            <Route path="/upload" render={(props) => (
                                <UploadDocument dim={this.state.dim} />
                            )} />

                            <Route path="/support" render={() => (
                                <Support dim={this.state.dim} />
                            )} />

                            {/* Redirect to Dashboard for any other Path */}
                            <Redirect to={
                                jsonValue && !!!jsonValue.actionMap 
                                ? '/dashboard' 
                                : (jsonValue.actionMap && jsonValue.actionMap.includes('dashboard')) 
                                  ? '/dashboard' 
                                  : (jsonValue.actionMap && jsonValue.actionMap.includes('smartClinic')) 
                                    ? '/smart-clinic'
                                    : (jsonValue.actionMap && jsonValue.actionMap.includes('infirmary')) 
                                      ? '/infirmary'
                                      : '/'
                            } />

                        </Switch>
                        {this.getChangePasswordModal()}
                    </div>                    
                    <ToastContainer />
                    {(window.innerWidth <= 767) &&
                        <NavDrawer
                            show={this.state.showNavDrawer}
                            sectionList={sectionList}
                            linkList={linkList}
                            onClickChild={(index) => this.props.setSelectedChild(index)}
                            onClickClose={() => {this.setState({showNavDrawer: false})}}
                            onClickTalkToExpert={() => {this.dashboard && this.dashboard.onClickTalkToExpert()}}
                        />}
            </section>  
            <div style = {{marginTop: 20}}>
                <HSGFooter />

            </div>
            </div>          
        )
    }


    // Event Listeners ==============================================

    updateDimensions() {
        this.setState({dim: this.getDim()})
    }


    setHeaderElement(e) {
        this.headerElement = e
    }


    // Other Methods ================================================

    getDim() {
        let contentHeight = 0
        let headerHeight = 0
        if(Boolean(this.headerElement)) {
            headerHeight = this.headerElement.offsetHeight
            contentHeight = this.rootElement.offsetHeight - headerHeight
        }

        return {
            width: this.rootElement.offsetWidth,
            height: this.rootElement.offsetHeight,
            contentHeight,
            headerHeight
        }
    }

}


export default withCookies(App)





// WEBPACK FOOTER //
// ./src/Containers/AppContainer/Component/App.js